function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
var Environment;
(function (Environment) {
  Environment["Production"] = "PRODUCTION";
  Environment["Test"] = "TEST";
  Environment["Development"] = "DEV";
})(Environment || (Environment = {}));
var Logger = /*#__PURE__*/function () {
  function Logger() {
    var environment = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Environment.Production;
    _classCallCheck(this, Logger);
    this.loggingServiceEnabled = false;
    this.loggingService = window.Rollbar;
    this.loggingServiceEnabled = !!this.loggingService;
    this.environment = Object.values(Environment).includes(environment) ? environment : Environment.Production;
  }
  _createClass(Logger, [{
    key: "debug",
    value: function debug(value) {
      var _a;
      if (this.loggingServiceEnabled) {
        (_a = this.loggingService) === null || _a === void 0 ? void 0 : _a.log(value);
      }
      if (this.environment !== Environment.Production) {
        console.log(value);
      }
    }
  }, {
    key: "warning",
    value: function warning(error) {
      var _a;
      if (!error) throw new TypeError("Invalid error type when logging warning. Type: ".concat(_typeof(error), ". Error: ").concat(error));
      if (this.loggingServiceEnabled) {
        (_a = this.loggingService) === null || _a === void 0 ? void 0 : _a.warn(error);
      }
      if (this.environment !== Environment.Production) {
        console.warn(error);
      }
    }
  }, {
    key: "error",
    value: function error(_error) {
      var _a;
      if (!_error) throw new TypeError("Invalid error type when logging error. Type: ".concat(_typeof(_error), ". Error: ").concat(_error));
      if (this.loggingServiceEnabled) {
        (_a = this.loggingService) === null || _a === void 0 ? void 0 : _a.error(_error);
      }
      if (this.environment !== Environment.Production) {
        console.error(_error);
      }
    }
  }, {
    key: "critical",
    value: function critical(error) {
      var _a;
      if (!error) throw new TypeError("Invalid error type when logging critical error. Type: ".concat(_typeof(error), ". Error: ").concat(error));
      if (this.loggingServiceEnabled) {
        (_a = this.loggingService) === null || _a === void 0 ? void 0 : _a.critical(error);
      }
      if (this.environment !== Environment.Production) {
        console.error(error);
      }
    }
  }]);
  return Logger;
}();
var emailValidationRegex = /^([-!#-'*+/-9=?A-Z^-~]+(\.[-!#-'*+/-9=?A-Z^-~]+)*|"(!#-[^-~ \t]|(\\[\t -~]))+")@([0-9A-Za-z]([0-9A-Za-z-]{0,61}[0-9A-Za-z])?(\.[0-9A-Za-z]([0-9A-Za-z-]{0,61}[0-9A-Za-z])?)*|\[((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|IPv6:((((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){6}|::((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){5}|[0-9A-Fa-f]{0,4}::((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){4}|(((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):)?(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}))?::((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){3}|(((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){0,2}(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}))?::((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){2}|(((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){0,3}(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}))?::(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):|(((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){0,4}(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}))?::)((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3})|(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3})|(((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){0,5}(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}))?::(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3})|(((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){0,6}(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}))?::)|(?!IPv6:)[0-9A-Za-z-]*[0-9A-Za-z]:[!-Z^-~]+)])$/;
var orderIdValidationRegex = /^[0-9]*$/;
var passwordValidationRegex = /^.*(?=.*\d)(?=.*[a-zA-Z])\S*$/;
var phoneNumberValidationRegex = /^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/;
var validateEmail = function validateEmail(value) {
  if (!value) return false;
  if (typeof value !== "string") return false;
  if (value.length <= 4) return false;
  if (value.length > 255) return false;
  if (!emailValidationRegex.test(value)) return false;
  return true;
};
var validateOrderNumber = function validateOrderNumber(value) {
  if (!value) return false;
  if (typeof value === "number") value = value.toString();
  if (typeof value !== "string") return false;
  if (!orderIdValidationRegex.test(value)) return false;
  return true;
};
var validateName = function validateName(value) {
  if (!value) return false;
  if (typeof value !== "string") return false;
  if (value.length <= 1) return false;
  if (value.length > 40) return false;
  return true;
};
var validatePassword = function validatePassword(value) {
  if (!value) return false;
  if (typeof value !== "string") return false;
  if (value.length <= 7) return false;
  if (value.length > 35) return false;
  if (!passwordValidationRegex.test(value)) return false;
  return true;
};
var validateConfirmPassword = function validateConfirmPassword(value, password) {
  if (typeof value !== "string" || typeof password !== "string") return false;
  return value === password;
};
var validateMessage = function validateMessage(value) {
  if (!value) return false;
  if (typeof value !== "string") return false;
  if (value.length < 5) return false;
  return true;
};
var validatePhoneNumber = function validatePhoneNumber(value) {
  if (!value) return false;
  if (typeof value !== "string") return false;
  if (value.length < 7) return false;
  if (value.length > 20) return false;
  if (!phoneNumberValidationRegex.test(value)) return false;
  return true;
};
var validateFullName = function validateFullName(value) {
  if (!value) return false;
  if (typeof value !== "string") return false;
  if (value.length <= 1) return false;
  if (value.length > 100) return false;
  if (value.split(" ").length <= 1) return false;
  return true;
};
function getCookie(name) {
  var value = (document.cookie.match("(?:^|;)\\s*" + name.trim() + "\\s*=\\s*([^;]*?)\\s*(?:;|$)") || [])[1];
  if (value === undefined) return "";
  return decodeURIComponent(value);
}
function setCookie(name, value, days, domain) {
  if (!name || !value) throw new Error("Missing parameter when calling setCookie");
  var date = new Date();
  var encodedValue = encodeURIComponent(value);
  var expires = "";
  if (days) {
    date.setDate(date.getDate() + days);
    expires = "expires=".concat(date.toUTCString(), ";");
  }
  var cookie = "".concat(name, "=").concat(encodedValue, "; ").concat(expires, " path=/;");
  if (domain) cookie += " domain=".concat(domain, ";");
  document.cookie = cookie;
}
function deleteCookie(name) {
  document.cookie = name + "=; expires=Thu, 01-Jan-70 00:00:01 GMT; path=/";
}

/**
 * @description Checks if the value is an object
 */
var isObject = function isObject(value) {
  return _typeof(value) === "object" && !Array.isArray(value) && value !== null;
};
/**
 * @description This debounce function limits the rate at which a specified function can fire by ensuring it is invoked only after the
 * specified delay has passed since the last time it was called.
 * This function delays the execution of a function (callback) until after a specified period (delay in milliseconds) has passed since the last time the function was called.
 */
function debounce(callback, delay) {
  var timer;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    clearTimeout(timer);
    timer = setTimeout(function () {
      callback.apply(void 0, args);
    }, delay);
  };
}
/**
 * @description Randomises the order of an array
 */
function shuffleArray(array) {
  for (var i = array.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var _ref = [array[j], array[i]];
    array[i] = _ref[0];
    array[j] = _ref[1];
  }
}
/**
 * @description A shorthand wrapper to select a singular DOM element
 */
function select(selector) {
  var element = document.querySelector(selector);
  if (!element) {
    return null;
  }
  return element;
}
/**
 * @description A shorthand wrapper to select a multiple DOM elements. Returns an empty NodeList if there's zero matches
 */
function selectAll(selector) {
  var elements = document.querySelectorAll(selector);
  return elements;
}
/**
 * @description Throttle running a function by a specified time.
 * This function ensures that a function (fn) is executed at most once every specified period (wait time in milliseconds), no matter how many times the function is called.
 */
function throttle(fn, wait) {
  var time = Date.now();
  return function () {
    if (time + wait - Date.now() < 0) {
      fn();
      time = Date.now();
    }
  };
}

/**
 * Shifts the current domain a level higher e.g. checkout.fruugo.com -> fruugo.com
 * @param {string} domain - Domain to shift
 * @returns
 */
function shiftDomain(domain) {
  if (!domain || typeof domain !== "string") throw new Error("Invalid domain value when attempting to shift domain");
  var domainLevels = domain.split(".");
  if (domainLevels && domainLevels.length > 2) {
    domainLevels.shift();
    domain = domainLevels.join(".");
  }
  return domain;
}
var consentCookieName = "consents";
var consentCookieExpiry = 180; // days
var defaultConsents = {
  essential: true,
  analytics: false,
  advertising: false
};
var getUserConsent = function getUserConsent() {
  var cookieValue = getCookie(consentCookieName);
  return convertCookieStringToConsent(cookieValue);
};
/**
 *
 * @param {Consent} consent - Object with consents values to set.
 * @param {boolean} globalConsent - Whether to set the consent across all fruugo projects by setting the cookie a domain level higher e.g. www.fruugo.co.uk -> .fruugo.co.uk. Defaults to true
 */
var setUserConsent = function setUserConsent(consent) {
  var globalConsent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (typeof consent === "undefined") consent = defaultConsents;
  if (!consent || !isObject(consent)) throw new TypeError("Invalid consent value type. Must be an object");
  setCookie(consentCookieName, convertConsentToCookieString(consent), consentCookieExpiry, globalConsent ? shiftDomain(location.hostname) : null);
};
function convertConsentToCookieString(consent) {
  var encoded = Object.entries(consent).filter(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      value = _ref3[1];
    return value === true;
  }).map(function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 1),
      key = _ref5[0];
    return key;
  }).join(",");
  return encoded;
}
function convertCookieStringToConsent(cookieValue) {
  if (!cookieValue) return null;
  var keys = cookieValue.split(",");
  // convert "foo,bar" into { foo: true, bar: true }
  var validKeys = keys.filter(function (key) {
    return defaultConsents[key] !== undefined;
  });
  // something unparseable in the cookie
  if (validKeys.length === 0) return null;
  // convert to object
  var tuples = validKeys.map(function (key) {
    return [key, true];
  });
  var storedConsents = Object.fromEntries(tuples);
  return Object.assign(Object.assign({}, defaultConsents), storedConsents);
}
function diffInDays(startDate, endDate) {
  if (!startDate || !endDate) throw new Error("Missing parameter when calling diffInDays");
  return Math.floor((endDate - startDate) / 1000 / 60 / 60 / 24);
}
function diffInHours(startDate, endDate) {
  if (!startDate || !endDate) throw new Error("Missing parameter when calling diffInHours");
  return Math.floor((endDate - startDate) / 1000 / (60 * 60));
}
function diffInMins(startDate, endDate) {
  if (!startDate || !endDate) throw new Error("Missing parameter when calling diffInMins");
  return Math.floor((endDate - startDate) / 60000 % 60);
}
export { Environment, Logger, debounce, defaultConsents, deleteCookie, diffInDays, diffInHours, diffInMins, getCookie, getUserConsent, isObject, select, selectAll, setCookie, setUserConsent, shiftDomain, shuffleArray, throttle, validateConfirmPassword, validateEmail, validateFullName, validateMessage, validateName, validateOrderNumber, validatePassword, validatePhoneNumber };
